








import { Component, Vue, Prop } from 'vue-property-decorator'
import { InvestigatorResult } from '@/class/game'

@Component
export default class ProclaimInvestigatorResultMessage extends Vue {
  @Prop() investigatorResult!: InvestigatorResult

  get messages () {
    const messages: string[] = []

    const result = this.investigatorResult.hasWeapon ? '武器を所持している' : '武器を所持していない'

    messages.push(`${this.playerName}さんが「${this.targetName}さんは${result}」と発表しました`)

    return messages
  }

  get playerName() {
    return this.investigatorResult.player.name
  }

  get targetName() {
    return this.investigatorResult.targetPlayer.name
  }
}
